var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#404042;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.2,20.6l-2.5,2.5c-1,1-2.7,1-3.8,0c-1-1-1-2.7,0-3.8l5-5c1-1,2.7-1,3.8,0c0.3,0.3,0.9,0.3,1.3,0 s0.3-0.9,0-1.3c-1.7-1.7-4.6-1.7-6.3,0l-5,5c-1.7,1.7-1.7,4.6,0,6.3c1.7,1.7,4.6,1.7,6.3,0l2.5-2.5c0.3-0.3,0.3-0.9,0-1.3 S13.5,20.3,13.2,20.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.4,5.6c-1.7-1.7-4.6-1.7-6.3,0l-3,3c-0.3,0.3-0.3,0.9,0,1.3c0.3,0.3,0.9,0.3,1.3,0l3-3c1-1,2.7-1,3.8,0 c1,1,1,2.7,0,3.8l-5.6,5.6c-1,1-2.7,1-3.8,0c-0.3-0.3-0.9-0.3-1.3,0c-0.3,0.3-0.3,0.9,0,1.3c1.7,1.7,4.6,1.7,6.3,0l5.6-5.6 C26.1,10.2,26.1,7.3,24.4,5.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.05ad2d725a349a58db05a8c76f18706d.svg";
export { ForwardRef as ReactComponent };